(function (w, $, _) {
    'use strict';

    function checkout(paymentId, $container, controller) {
        var _paymentId = paymentId;
        var _$container = $container;
        var _controller = controller, _ui;
        var _checkInScriptUrl, _checkIn, _paymentMenuScriptUrl, _paymentMenu;
        var _billingDetailsUrl, _shippingDetailsUrl, _consumerProfileRef;
        var _asset = w.umwAssets['swedbank_pay'][0];
        var _updateOrderTimer;

        var _initUi = function () {
            var templateData = {
                labels: _asset.labels,
                description: _asset.description
            };
            var checkoutForm = _.template(_asset.template, templateData);

            _$container.append(checkoutForm);
            _ui = {};
            _ui.$lbTotalPrice = _$container.find('.js-swedbankpay-total-price');
            _ui.$lbPriceExlVatMsg = _$container.find('.js-swedbankpay-price-excl-vat-msg');
            _ui.$resetOrderInSwedbank = _$container.find('.js-resetOrderInSwedbank');
            _ui.$loginHelpText = _$container.find('.js-loginHelpText');
            _ui.$updateAddressInSwedbankHelpText = _$container.find('.js-updateAddressInSwedbankHelpText');

            _ui.$resetOrderInSwedbank.hide();
            _ui.$updateAddressInSwedbankHelpText.hide();

            _ui.$resetOrderInSwedbank.click(function(e) {
                e.preventDefault();
                _billingDetailsUrl = _shippingDetailsUrl = _consumerProfileRef = null;
                _controller.resetOrder();
            });
        };
        var _reInitUi = function () {
            _$container.empty();
            _initUi();
        };
        function updateTotalPriceUi(checkoutOrder) {
            _ui.$lbTotalPrice.text(checkoutOrder.sellPriceTotal);

            if (typeof checkoutOrder.includeVAT === 'boolean') {
                _ui.$lbPriceExlVatMsg.toggle(!checkoutOrder.includeVAT);
            }
        }
        var _handleUpdatedOrder = function(checkoutOrder) {
            var $deferred = $.Deferred();
            var script, isReInitUiNeeded = false;

            if (checkoutOrder.checkInScriptUrl) {
                if (_checkInScriptUrl && _checkInScriptUrl !== checkoutOrder.checkInScriptUrl) {
                    isReInitUiNeeded = true;
                }
            }

            if (checkoutOrder.paymentMenuScriptUrl) {
                if (_paymentMenuScriptUrl && _paymentMenuScriptUrl !== checkoutOrder.paymentMenuScriptUrl) {
                    isReInitUiNeeded = true;
                }
            }
            if (isReInitUiNeeded) {
                // workaround - just reload whole page, because removing scripts doesn't help and later errors in console appear
                var loc = window.location;
                window.location = loc.protocol + '//' + loc.host + loc.pathname + loc.search;
                return $deferred.promise();

                /*if (_checkInScriptUrl) {
                    $('script[src="' + _checkInScriptUrl + '"]').remove();
                }
                if (_paymentMenuScriptUrl) {
                    $('script[src="' + _paymentMenuScriptUrl + '"]').remove();
                }
                if (w.payex) {
                    delete w.payex;
                }
                _checkIn = null;
                _paymentMenu = null;
                _reInitUi();*/
            }

            updateTotalPriceUi(checkoutOrder);

            let loginHelpTextVisible = false;

            if (checkoutOrder.checkInScriptUrl) {
                loginHelpTextVisible = true;
                if (!_checkIn) {
                    _checkInScriptUrl = checkoutOrder.checkInScriptUrl;
                    script = document.createElement('script');
                    script.setAttribute('src', checkoutOrder.checkInScriptUrl);
                    script.onload = function () {
                        _checkIn = w.payex.hostedView.consumer({
                            // The container specifies which id the script will look for to host the check in component
                            container: 'swedbankPay-check-in',
                            onConsumerIdentified: function (consumerIdentifiedEvent) { // !! this event will not trigger if you break in debugging onBillingDetailsAvailable or onShippingDetailsAvailable events
                                _consumerProfileRef = consumerIdentifiedEvent.consumerProfileRef;
                                if (_updateOrderTimer) {
                                    w.clearTimeout(_updateOrderTimer);
                                    _updateOrderTimer = null;
                                }
                                _controller.updateOrder(true); // true to block UI while updating
                            },
                            onBillingDetailsAvailable: function (billingDetailsAvailableEvent) {
                                _billingDetailsUrl = billingDetailsAvailableEvent.url;
                                if (_updateOrderTimer) {
                                    w.clearTimeout(_updateOrderTimer);
                                }
                                _updateOrderTimer = w.setTimeout(function() { _controller.updateOrder(true); }, 1000);
                            },
                            onShippingDetailsAvailable: function (shippingDetailsAvailableEvent) {
                                _shippingDetailsUrl = shippingDetailsAvailableEvent.url;
                                if (_updateOrderTimer) {
                                    w.clearTimeout(_updateOrderTimer);
                                }
                                _updateOrderTimer = w.setTimeout(function() { _controller.updateOrder(true); }, 1000);
                            }
                        });
                        _checkIn.open();
                        if (!checkoutOrder.paymentMenuScriptUrl) {
                            $deferred.resolve();
                        }
                    };
                    // Append the script to the head
                    document.getElementsByTagName('head')[0].appendChild(script);
                } else {
                    _checkIn.update();
                    if (!checkoutOrder.paymentMenuScriptUrl) {
                        $deferred.resolve();
                    }
                }
            }

            if (checkoutOrder.paymentMenuScriptUrl) {
                loginHelpTextVisible = false;
                if (_paymentMenu) {
                    // update the Payment Menu after any changes to the order
                    _paymentMenu.refresh();
                    $deferred.resolve();
                } else {
                    _paymentMenuScriptUrl = checkoutOrder.paymentMenuScriptUrl;
                    script = document.createElement('script');
                    script.setAttribute('src', checkoutOrder.paymentMenuScriptUrl);
                    script.onload = function() {
                        _paymentMenu = w.payex.hostedView.paymentMenu({
                            container: 'swedbankPay-payment-menu',
                            culture: checkoutOrder.paymentMenuLocale,
                            onPaymentCompleted: function(paymentCompletedEvent) {
                                window.location.href = paymentCompletedEvent.redirectUrl;
                            },
                            onPaymentFailed: function() {
                                $deferred.reject();
                            },
                            onPaymentCanceled: function() {
                                $deferred.reject();
                            },
                            onPaymentTransactionFailed: function() {
                                $deferred.reject();
                            },
                            onPaymentCreated: function() {
                                $deferred.resolve();
                            },
                            onError: function(error) {
                                console.error(error);
                                $deferred.reject();
                            },
                        });
                        _paymentMenu.open();
                    };
                    // Append the script to the head
                    document.getElementsByTagName('head')[0].appendChild(script);
                }
                _ui.$resetOrderInSwedbank.show();
                _ui.$updateAddressInSwedbankHelpText.show();
            }

            _ui.$loginHelpText.toggle(loginHelpTextVisible);

            return $deferred.promise();
        };

        _initUi();

        return {
            getPaymentId: function () { return _paymentId; },
            getSpecifics: function () {
                return {
                    name: 'Swedbank Pay',
                    canDisableDeliveryPostalCode: false
                };
            },
            getOrderFormValues: function () {

                var providerData = {
                    consumerProfileRef: _consumerProfileRef,
                    billingDetailsUrl: _billingDetailsUrl,
                    shippingDetailsUrl: _shippingDetailsUrl,
                };

                var orderForm = {
                    paymentProviderInternalData: JSON.stringify(providerData),
                };

                return orderForm;
            },
            suspendForUpdate: function () {
                // parent control (212) blocks the UI - no need to suspend here
            },
            handleUpdatedOrder: _handleUpdatedOrder
        };
    }

    if (!w.checkoutProviders) {
        w.checkoutProviders = {};
    }

    w.checkoutProviders.SwedbankPay = checkout;

})(window, jQuery, _);